import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const PersonAddIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="M12.5 17.5a5 5 0 1 0 10 0 5 5 0 0 0-10 0ZM17.5 15v5M20 17.5h-5M10 18.5H2.5a8.719 8.719 0 0 1 .7-3.322c.49-.981 2.539-1.661 5.111-2.613.695-.258.581-2.074.273-2.413a5.127 5.127 0 0 1-1.34-3.978A3.354 3.354 0 0 1 10.5 2.5a3.354 3.354 0 0 1 3.256 3.674 5.126 5.126 0 0 1-1.336 3.978c-.216.238-.337 1.204-.149 1.848"
            />
        </svg>
    </IconWrapper>
)
